import styled from '@emotion/styled';

export const SearchPageContainer = styled.div`
  display: flex;
  flex-direction: column;
`;
